export default "__VITE_ASSET__CM0xHg3y__"